export default __webpack_public_path__ + "static/media/hero_logo_horizontal.dfb29646.png";